import * as React from 'react';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
const style = require('./index.css');

export interface IHeaderProps {
  includeNewMoscow: boolean | undefined;
  onNewMoscowSwitched(includeNewMoscow: boolean | undefined): void;
}

export class MoscowDistrictsHeader extends React.Component<IHeaderProps> {
  public render() {
    return (
      <div className={style.header}>
        <ButtonCheckbox
          buttonStyle={style.districtButton}
          onValueChange={() => {
            this.props.onNewMoscowSwitched(this.props.includeNewMoscow ? undefined : true);
          }}
          value={this.props.includeNewMoscow === undefined ? false : this.props.includeNewMoscow}
        >
          Новая Москва
        </ButtonCheckbox>

        <ButtonCheckbox
          buttonStyle={style.districtButton}
          onValueChange={() => {
            this.props.onNewMoscowSwitched(
              this.props.includeNewMoscow === undefined
                ? false
                : this.checkWithoutNewMoscow(this.props.includeNewMoscow),
            );
          }}
          value={this.props.includeNewMoscow === undefined ? false : !this.props.includeNewMoscow}
        >
          Москва без Новой Москвы
        </ButtonCheckbox>
      </div>
    );
  }

  private checkWithoutNewMoscow = (includeNewMoscow: boolean) => {
    return includeNewMoscow ? false : undefined;
  };
}
